import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaPlay, FaTools, FaMobileAlt, FaCertificate, FaClock } from 'react-icons/fa';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  
  // Default State (Fallback data)
  const [data, setData] = useState({
    badgeText: 'Watch Our Work',
    title: 'See How Solar Installation Works',
    subtitle: 'Watch our NIT & DTU engineer team install solar systems across Bihar & Jharkhand',
    videoId: 'dQw4w9WgXcQ', // Default YouTube ID
    
    stat1Label: 'Installation Time', stat1Value: '2-4 Days',
    stat2Label: 'Projects Completed', stat2Value: '500+',
    stat3Label: 'Quality Assured', stat3Value: '100%',

    benefit1Title: 'Engineer-Led Installation', benefit1Desc: 'NIT & DTU qualified engineers supervise every installation...',
    benefit2Title: 'Quick & Professional Setup', benefit2Desc: 'Complete installation in just 2-4 days...',
    benefit3Title: 'Online Monitoring Platform', benefit3Desc: 'Track real-time energy generation...',
    benefit4Title: 'Complete Documentation', benefit4Desc: 'We handle all paperwork: subsidy application...'
  });



  // Fetch Data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
    const res = await api.get('/Video');
        if (res.data) {
          // Mapping backend fields to state
          setData({
            badgeText: res.data.badgeText,
            title: res.data.title,
            subtitle: res.data.subtitle,
            videoId: res.data.videoId,
            
            stat1Label: res.data.stat1_Label, stat1Value: res.data.stat1_Value,
            stat2Label: res.data.stat2_Label, stat2Value: res.data.stat2_Value,
            stat3Label: res.data.stat3_Label, stat3Value: res.data.stat3_Value,

            benefit1Title: res.data.benefit1_Title, benefit1Desc: res.data.benefit1_Desc,
            benefit2Title: res.data.benefit2_Title, benefit2Desc: res.data.benefit2_Desc,
            benefit3Title: res.data.benefit3_Title, benefit3Desc: res.data.benefit3_Desc,
            benefit4Title: res.data.benefit4_Title, benefit4Desc: res.data.benefit4_Desc,
          });
        }
      } catch (err) {
        console.error("Error fetching Video Section data", err);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="video-section py-5 bg-white" id="video">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-5">
          <span className="badge bg-success mb-3 px-3 py-2">
            <i className="bi bi-play-circle-fill me-2"></i>
            {data.badgeText}
          </span>
          <h2 className="display-5 fw-bold text-dark mb-3">
            {data.title}
          </h2>
          <p className="lead text-muted">
            {data.subtitle}
          </p>
        </div>

        <div className="row g-4">
          {/* Video Player */}
          <div className="col-lg-7">
            <div className="video-wrapper position-relative shadow-lg rounded overflow-hidden">
              {!isPlaying ? (
                <div 
                  className="video-placeholder position-relative"
                  onClick={() => setIsPlaying(true)}
                  style={{
                    height: '500px',
                    background: 'linear-gradient(135deg, rgba(27, 63, 110, 0.95) 0%, rgba(0, 208, 132, 0.9) 100%)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <div className="play-button position-relative" style={{ width: '120px', height: '120px', background: 'rgba(255, 255, 255, 0.25)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(10px)', border: '4px solid rgba(255, 255, 255, 0.3)' }}>
                    <FaPlay style={{ fontSize: '3rem', color: '#ffffff', marginLeft: '8px' }} />
                  </div>
                  <div className="video-overlay position-absolute text-white" style={{ bottom: '30px', left: '30px', right: '30px' }}>
                    <h3 className="fw-bold mb-2">Watch Video</h3>
                    <p className="mb-0 opacity-75">Click to play</p>
                  </div>
                </div>
              ) : (
                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                  <iframe
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    src={`https://www.youtube.com/embed/${data.videoId}?autoplay=1&rel=0`}
                    title="Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </div>

            {/* Video Stats Below */}
            <div className="row g-3 mt-3">
              <div className="col-4">
                <div className="card border-0 shadow-sm text-center p-3">
                  <h4 className="fw-bold mb-1" style={{ color: '#00D084' }}>{data.stat1Value}</h4>
                  <small className="text-muted">{data.stat1Label}</small>
                </div>
              </div>
              <div className="col-4">
                <div className="card border-0 shadow-sm text-center p-3">
                  <h4 className="fw-bold mb-1" style={{ color: '#00D084' }}>{data.stat2Value}</h4>
                  <small className="text-muted">{data.stat2Label}</small>
                </div>
              </div>
              <div className="col-4">
                <div className="card border-0 shadow-sm text-center p-3">
                  <h4 className="fw-bold mb-1" style={{ color: '#00D084' }}>{data.stat3Value}</h4>
                  <small className="text-muted">{data.stat3Label}</small>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits List (Dynamic) */}
          <div className="col-lg-5">
            <div className="video-benefits h-100 d-flex flex-column justify-content-center">
              <h4 className="fw-bold mb-4" style={{ color: '#1B3F6E' }}>
                Why Choose Us?
              </h4>

              {/* Benefit 1 */}
              <div className="benefit-point d-flex mb-4">
                <div className="benefit-icon-wrapper flex-shrink-0 me-3" style={{width:'60px', height:'60px', background:'linear-gradient(135deg, #00D084 0%, #00A86B 100%)', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <FaTools style={{ fontSize: '1.8rem', color: '#ffffff' }} />
                </div>
                <div className="flex-grow-1">
                  <h5 className="fw-bold mb-2" style={{ color: '#1B3F6E' }}>{data.benefit1Title}</h5>
                  <p className="text-muted mb-0">{data.benefit1Desc}</p>
                </div>
              </div>

              {/* Benefit 2 */}
              <div className="benefit-point d-flex mb-4">
                <div className="benefit-icon-wrapper flex-shrink-0 me-3" style={{width:'60px', height:'60px', background:'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <FaClock style={{ fontSize: '1.8rem', color: '#ffffff' }} />
                </div>
                <div className="flex-grow-1">
                  <h5 className="fw-bold mb-2" style={{ color: '#1B3F6E' }}>{data.benefit2Title}</h5>
                  <p className="text-muted mb-0">{data.benefit2Desc}</p>
                </div>
              </div>

              {/* Benefit 3 */}
              <div className="benefit-point d-flex mb-4">
                <div className="benefit-icon-wrapper flex-shrink-0 me-3" style={{width:'60px', height:'60px', background:'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <FaMobileAlt style={{ fontSize: '1.8rem', color: '#ffffff' }} />
                </div>
                <div className="flex-grow-1">
                  <h5 className="fw-bold mb-2" style={{ color: '#1B3F6E' }}>{data.benefit3Title}</h5>
                  <p className="text-muted mb-0">{data.benefit3Desc}</p>
                </div>
              </div>

              {/* Benefit 4 */}
              <div className="benefit-point d-flex mb-4">
                <div className="benefit-icon-wrapper flex-shrink-0 me-3" style={{width:'60px', height:'60px', background:'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <FaCertificate style={{ fontSize: '1.8rem', color: '#ffffff' }} />
                </div>
                <div className="flex-grow-1">
                  <h5 className="fw-bold mb-2" style={{ color: '#1B3F6E' }}>{data.benefit4Title}</h5>
                  <p className="text-muted mb-0">{data.benefit4Desc}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;